import './withdraw.scss';

import React, { FunctionComponent } from 'react';
import { Amount } from '../../amount/amount';
import { useAppSelector } from '../../../../features';
import { getQuotationInfo } from '../../../../store/TransactionSlice';

export type WithDrawDataProps = {
    category: string,
    amount: number,
    currency?: string,
    qty?: number
}

const slippageLocal = localStorage.getItem('slippage');

export const WithDrawCards: FunctionComponent<WithDrawDataProps> = (props) => {

    const quotations            = useAppSelector(getQuotationInfo);

    const labelFormatter = (s:string) => {
        if (s === `pending`) return "Em Processo"
        if (s === `failed`) return "Esperando Execução"
        return "Finalizadas";
    }

    return (
        <>
            {props.category === 'none' &&
                <div className="card card-withdraw">
                    <div className="card-body">
                        <p>
                            
                            Não há nenhuma transação em aberta ou pendente. 
                            Todas as suas ordens foram executadas. Agora só continuar com o processo.
                        </p>
                    </div>
                </div>
            }
            {props.category !== 'none' &&
                <div className="card card-withdraw">
                    <div className="card-body">
                        <div className="flex line-up">
                            <div className="date">
                                { props.category === 'pending' ? "Dia de Hoje" : ""}
                            </div>
                            <div className="status">
                                {labelFormatter(props.category)}
                            </div>
                        </div>
                        <div className="flex info">
                            <div className="title">
                                { props.category === 'pending' ? "Valor a ser realizado" : "Valor total de swap:"}
                            </div>
                            <Amount value={props.amount || 0} format={false} currency={props.currency}/>
                        </div>
                        <div className="flex info">
                            <div className="title">
                                Valor atual USDT
                            </div>
                            <Amount value={quotations?.price || 0} format={false} currency={props.currency}/>
                        </div>
                        { /*props.category === 'pending' && (
                            <div className="flex slip">
                                <div className="title">Slippage</div>
                                <div className="value">
                                    { !slippageLocal ? 'Valor de mercado' : slippageLocal }
                                </div>
                            </div>
                        )*/}
                        { props.qty && props.qty > 0 && (
                            <div className="flex slip">
                                <div className="title">Quantidades de ordens</div>
                                <div className="value"> {props.qty}
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            }
        </>
    )
}